import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import defer from 'lodash/defer';
export default {
  name: 'SmartBanner',
  props: {
    storeUrl: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      platform: '',
      showBan: false,
      mobile: false
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    type() {
      return {
        path: 'description',
        args: {
          x: this.platform
        }
      };
    }

  }),

  mounted() {
    this.getUserAgent();
    this.mobile = this.isMobile();
    defer(() => {
      if (this.platform) {
        this.showBan = true;
      }
    });
  },

  methods: {
    metaIos() {
      const authorizedMarkets = ['FR', 'DE', 'ES', 'IT', 'UK', 'PT', 'LU', 'AT'];
      let mstore = {};

      if (authorizedMarkets.indexOf(this.locale.market) !== -1) {
        mstore = {
          name: 'apple-itunes-app',
          content: 'app-id=1425027693'
        };
      }

      return mstore;
    },

    tracking() {
      return {
        data: {
          event_category: 'App_Innersense',
          event_action: 'Clic_Button',
          event_label: 'Android'
        }
      };
    }

  },

  head() {
    return {
      meta: [{
        name: 'google-play-app',
        content: 'app-id=com.innersense.osmose.android.maisonsdumonde'
      }, this.metaIos()]
    };
  }

};